// Code generated by master-scheme ServiceTypesGenerator - DO NOT EDIT
// Generator: /Users/victorvins/Projects/master-scheme/dsl/src/ts-api/ServiceTypesGenerator.scala

import { postEndpoint } from '@innolab-trader/tradovate-transport'
import type { ValidationError } from '@innolab-trader/tradovate-types'

export interface DeleteBankAccount {
  bankAccountId: number
}

export interface SimpleResponse {
  errorText?: string
  ok: boolean
}

/**
 * Validate DeleteBankAccount request
 *
 * Follows Rust validation pattern with structured errors
 *
 * @param request - The request object to validate
 * @returns Array of validation errors, empty if valid
 *
 * @example
 * ```typescript
 * const errors = validateDeleteBankAccount(requestData)
 * if (errors.length > 0) {
 *   return { status: 400, errors }
 * }
 * ```
 */
export function validateDeleteBankAccount(request: DeleteBankAccount): ValidationError[] {
  const errors: ValidationError[] = []

  const req = request as unknown as Record<string, unknown>
  if (req.bankAccountId === undefined || req.bankAccountId === null) {
    errors.push({
      field: 'bankAccountId',
      code: 'required',
      message: 'bankAccountId is required'
    })
  }

  return errors
}

export const deleteBankAccount = postEndpoint<DeleteBankAccount, SimpleResponse>('/bankAccount/deleteBankAccount')
